import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledCRMListContainer = styled(FlexColumn)`
    width: 100%;
`;

export const StyledCrmIcon = styled(SWReactIcons)`
    margin-right: 16px;
`;
